import React from "react"
import { Select, Stack, Text } from "@chakra-ui/react"

type Key = "name" | "value" | "values"

type Props = {
  option: Record<Key, Array<string>>
  showTitle?: boolean
  loading: boolean
  activeOptions: Array<Record<Key, string>>
  handleOptions: (option: any) => void
  key: string
}
const ProductOptions: React.FC<Props> = ({ option, showTitle, activeOptions, handleOptions, loading, key }) => {
  const selectedValue = activeOptions?.find(({ name }: any) => name === option?.name)?.value
  return (
    <Stack flexGrow={1} key={key}>
      {showTitle && (
        <Text as="label" variant="label">
          {option.name}
        </Text>
      )}
      <Select onChange={({ target: { value } }) => handleOptions({ name: option.name, value })} value={selectedValue} isDisabled={loading}>
        <option disabled>{option.name}</option>
        {option.values?.map((value: string) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </Select>
    </Stack>
  )
}

export default ProductOptions
